import React, { Component } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import moment from "moment";
import withFetchHook from "../withFetchHook";
import { sendStaffAppMetaData } from '../staffApp/eventTriggers'

class TherapistFormModal extends Component {
  handleClose() {
    this.props.closeModal();
  }

  handleChange(name, value) {
    this.props.updateField(name, value);
  }

  updateResidentTherapists(therapist) {
    const { organizationName, resident } = this.props;

    return this.props.fetch(`/organizations/${organizationName}/residents/${resident.id}.json`, {
      method: "PATCH",
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        resident: {
          therapists_attributes: [therapist]
        }
      })
    })
  }

  setDefaultStaffAppMetaData = () => sendStaffAppMetaData(this.props.tabDefaultMetaData)

  updateResidentTherapistsAction = () => {
    return (dispatch, getState) => {
      const state = getState()
      return this.props.fetch(`/organizations/${state.organization.name}/residents/${state.resident.id}.json`, {
        method: "PATCH",
        headers: {'Content-Type': 'application/json'},
        data: JSON.stringify({
          resident: {
            therapists_attributes: [state.ui.therapistModal.therapist]
          }
        })
      }).then(data=>{
        dispatch({ type: "UPDATE_THERAPISTS", payload: { therapists: data.therapists } })
        this.setDefaultStaffAppMetaData()
      })
    }
  }

  deleteTherapist() {
    const { therapist, deleteTherapist, closeModal, isStaffApp } = this.props;

    this.setState({ loading: true });

    this.updateResidentTherapists({
      id: therapist.id,
      _destroy: true
    }).then(() => {
      this.setState({ loading: false });
      deleteTherapist(therapist);
      closeModal();
      if (isStaffApp ) {
        alert("Doctor successfully deleted.")
        this.setDefaultStaffAppMetaData()
      }
    });
  }

  saveTherapist() {
    const { therapist, updateTherapists, closeModal, isStaffApp } = this.props;

    this.setState({ loading: true });

    this.updateResidentTherapists(therapist).then((data) => {
      this.setState({ loading: false })
      updateTherapists(data.therapists)
      closeModal()
      if (isStaffApp) {
        alert("Changes were successfully saved.")
        this.setDefaultStaffAppMetaData()
      }
    });
  }

  saveTherapistFunction = (e) => {
    this.props.dispatch(this.saveTherapist())
  }
  
  componentDidMount() {
    document.addEventListener('saveTherapist', this.saveTherapistFunction)
  }

  componentWillUnmount() {
    document.removeEventListener('saveTherapist', this.saveTherapistFunction)
  }

  render() {
    const { doctor_name, admitted_at, discharged_at } = this.props.therapist;
    const { isStaffApp, action, hasDelete, hasEdit } = this.props

    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)} style={{ height: '48vh' }}>
        {
          !isStaffApp &&
          <Modal.Header closeButton>
            <Modal.Title>Therapist/Clinician</Modal.Title>
          </Modal.Header>
        }
       <Modal.Body className={hasEdit ? "" : "form-modal-width"}>
          {hasEdit ? (
            <>
              <Form.Group controlId="TherapistDoctorName">
                <Form.Label>Doctor Name</Form.Label>
                <Form.Control
                  value={doctor_name}
                  onChange={(e) => this.handleChange('doctor_name', e.target.value)} />
              </Form.Group>
              <Row>
                <Col sm={5}>
                  <Form.Group controlId="TherapistAdmittedAt" style={{ position: "fixed", zIndex: 9999 }}>
                    <Form.Label>First Visit</Form.Label>
                    <div></div>
                    <DatePicker
                      className="form-control"
                      selected={admitted_at ? moment(admitted_at) : null}
                      onChange={(date) => {
                        this.handleChange(
                          'admitted_at',
                          date ? date.format("YYYY-MM-DD") : null
                        );
                      }} />
                  </Form.Group>
                </Col>
                <Col sm={5}>
                  <Form.Group controlId="TherapistDischargedAt" style={{ position: "fixed", zIndex: 9999 }}>
                    <Form.Label>Last Visit</Form.Label>
                    <div></div>
                    <DatePicker
                      className="form-control"
                      selected={discharged_at ? moment(discharged_at) : null}
                      onChange={(date) => {
                        this.handleChange(
                          'discharged_at',
                          date ? date.format("YYYY-MM-DD") : null
                        );
                      }} />
                  </Form.Group>
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Form.Group>
                <Form.Label>Doctor Name</Form.Label>
                <div className="form-control-plaintext">{doctor_name || 'N/A'}</div>
              </Form.Group>
              <Row>
                <Col sm={5}>
                  <Form.Group>
                    <Form.Label>First Visit</Form.Label>
                    <div className="form-control-plaintext">{admitted_at ? moment(admitted_at).format('MM/DD/YYYY') : 'N/A'}</div>
                  </Form.Group>
                </Col>
                <Col sm={5}>
                  <Form.Group>
                    <Form.Label>Last Visit</Form.Label>
                    <div className="form-control-plaintext">{discharged_at ? moment(discharged_at).format('MM/DD/YYYY') : 'N/A'}</div>
                  </Form.Group>
                </Col>
              </Row>
            </>
          )}
        </Modal.Body>
        {
          !isStaffApp ?
          <Modal.Footer style={{ marginBottom: '37px' }}>
            {
              action === "edit" && hasDelete &&
              <Button
                variant="outline-danger"
                onClick={() => this.deleteTherapist()}>
                Delete
              </Button>
            }
            <Button
              variant="info"
              onClick={() => this.saveTherapist()}>
              {action === "edit" ? "Update" : "Create"}
            </Button>
          </Modal.Footer> :
          <div className="p-4">
            {
              action == 'edit' && hasDelete &&
              <Button
                variant="outline-danger w-100"
                onClick={()=>this.deleteTherapist()}>
                Delete
              </Button>
            }
          </div>
        }
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.therapistModal.show,
    therapist: state.ui.therapistModal.therapist,
    action: state.ui.therapistModal.action,
    organizationName: state.organization.name,
    resident: state.resident,
    resident_tabs: state.config.resident_tabs,
    isStaffApp: state.config.isStaffApp,
    tabDefaultMetaData: state.config.tab_default_meta_data.find(tab=> tab.detail == 'doctors'),
    hasDelete: state.current_user.permissions.includes('Delete'),
    hasEdit: state.current_user.permissions.includes('Edit'),
    config: state.config,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => {
      dispatch({
        type: "CLOSE_RESOURCE_MODAL",
        payload: { resourceName: "therapist" }
      });
    },
    updateField: (name, value) => {
      dispatch({
        type: "UPDATE_RESOURCE_FIELD",
        payload: { resourceName: "therapist", name, value }
      });
    },
    updateTherapists: (therapists) => {
      dispatch({
        type: "UPDATE_THERAPISTS",
        payload: { therapists }
      });
    },
    createTherapist: (therapist) => {
      dispatch({
        type: "CREATE_THERAPIST",
        payload: { therapist }
      });
    },
    deleteTherapist: (therapist) => {
      dispatch({
        type: "DELETE_THERAPIST",
        payload: { therapist }
      })
    },
    dispatch: (func) => dispatch(func()),
  };
}

export default withFetchHook(connect(mapStateToProps, mapDispatchToProps)(TherapistFormModal));
